import {
  CheckboxFilter,
  FilterLabel,
} from "@/components/filters/types/filters.types";

export const translateFilter = (filter: CheckboxFilter) => {
  if (filter.kind === "Fuel") {
    switch (filter.name) {
      case "Diesel":
        return "Diesel";
      case "Gasolin":
        return "Bensin";
      case "GasolinAndElectricity":
        return "Bensin Hybrid";
      case "DieselAndElectricity":
        return "Diesel Hybrid";
      case "Electricity":
        return "Elektrisk";
      case "GasolinAndGas":
        return "Bensin/Naturgass"
    }
  }

  if (filter.kind === "Equipment") {
    switch (filter.name) {
      case "TowHitch":
        return "Tilhengerfeste";
    }
  }

  if (filter.kind === "DriveWheel") {
    switch (filter.name) {
      case "FrontWheelDrive":
        return "Forhjulsdrift";
      case "RearWheelDrive":
        return "Bakhjulsdrift";
      case "FourWheelDrive":
        return "Firehjulsdrift";
    }
  }

  if (filter.kind === "Availability") {
    switch (filter.name) {
      case "InStock":
        return "På lager";
      case "Coming":
        return "Kommer";
    }
  }
};

export const translateFilterLabels = (filterLabel: FilterLabel) => {
  switch (filterLabel) {
    case "BrandsWithModels":
      return "Merke og modell";
    case "Price":
      return "Pris";
    case "ModelYear":
      return "Årsmodell";
    case "Fuel":
      return "Drivstoff";
    case "DriveWheel":
      return "Drivverk";
    case "Mileage":
      return "Kilometerstand";
    case "Departments":
      return "Velg utsalgssted";
    case "Equipment":
      return "Egenskaper";
    case "SalesType":
      return "Salgsform";
    case "Color":
      return "Farge";
    case "Availability":
      return "Tilgjengelighet";
  }
};
